import { SectionWrapper } from 'remote-com-shared/components/SectionWrapper';
import { transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { whenProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { fromTabletBreakpoint } from '@/src/domains/shared/breakpoints';
import {
  RightBG,
  PartnersLogoSlice as PartnersLogoSliceComponent,
} from '@/src/views/ContractorLP/Slices/PartnersLogoSlice';

const SectionComponent = styled.div`
  ${SectionWrapper} {
    background-color: #fceef1;

    ${whenProp(
      '$addPaddingTop',
      css`
        ${fromTabletBreakpoint(css`
          margin-top: -140px;
          padding-top: 250px;
        `)}
      `
    )}
  }

  ${RightBG} {
    --sideGradient: linear-gradient(
      270deg,
      #fceef1 0%,
      rgba(255, 255, 255, 0.01) 99.99%,
      rgba(244, 244, 244, 0) 100%,
      #fceef1 100%
    );
  }

  h1,
  h2 {
    color: var(--color-tone-font);
  }
`;

export function PartnersLogoSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { addPaddingTop } = primary;
  return (
    <SectionComponent $addPaddingTop={addPaddingTop}>
      <PartnersLogoSliceComponent slice={slice} />
    </SectionComponent>
  );
}
